<lua-tag class="di-tag-suivi-facture" *ngIf="tagLabel && tagColor && tagMode" [label]="tagLabel" [color]="tagColor"
	[mode]="tagMode">
</lua-tag>